// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"d52ef0a7","63":"5ffed5e1"}[chunkId] + ".chunk.css";
};